// Manually maintained Spotify follower counts from Iva Gonzo's public Spotify profile snapshot.
// Source screenshot provided by user on 2026-05-12.
export const PLAYLIST_FOLLOWER_COUNTS = Object.freeze({
  'dark-side': 21251,
  'fresh-blood': 14287,
  'diamonds-bullets': 5899,
  'private-paradise': 11597,
  'infinite-dreams': 9905,
  'uncontrollable': 16161,
  'beach-hype': 9694,
  'dance-or-die': 4031,
  'nitro-go': 3014,
  'trippy-glitch': 938,
});

export function formatFollowerCount(value) {
  const count = Number(value) || 0;
  return count.toLocaleString('en-US');
}

export function getFollowerDisplayCount(value) {
  const count = Math.max(0, Math.floor(Number(value) || 0));
  if (count < 100) return count;
  return Math.floor(count / 100) * 100;
}

export function formatFollowerDisplayCount(value) {
  return `${formatFollowerCount(getFollowerDisplayCount(value))}+`;
}

export function getPlaylistFollowerCount(playlistId) {
  return PLAYLIST_FOLLOWER_COUNTS[playlistId] || 0;
}

export function getPlaylistFollowerDisplayCount(playlistId) {
  return getFollowerDisplayCount(getPlaylistFollowerCount(playlistId));
}

export function getPlaylistFollowerLabel(playlistId) {
  const count = getPlaylistFollowerCount(playlistId);
  return `${formatFollowerDisplayCount(count)} Spotify followers`;
}
